import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a094aca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "widget-tooltip-box" }
const _hoisted_2 = { class: "widget-tooltip-text" }

import { ref, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    text: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
        text?: string;
    }

const isShown = ref(null);



    

const show = () => {
    if(isShown.value)
        return;
    isShown.value = true;
    document.addEventListener('pointerdown',clickHandler);
};

const clickHandler = () => {
    if(isShown.value)
        close();
}


const close = () => {
    if(!isShown.value)
        return;
    isShown.value = false;
    
    document.removeEventListener('pointerdown',clickHandler);
};

expose({
    show,
    close
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    (isShown.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["widget-tooltip", isShown.value ? 'widget-tooltip-show' : ''])
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(__props.text), 1)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})